import React, { useState } from 'react';
import './NewChatModal.css';

const NewChatModal = ({ isOpen, onClose, onStartChat }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Validar número de teléfono de República Dominicana
    const cleaned = phoneNumber.replace(/[+\s\-()]/g, '');
    
    if (!cleaned || cleaned.length < 10) {
      setError('Por favor ingresa un número de teléfono válido de República Dominicana');
      return;
    }

    // Normalizar número para República Dominicana
    let normalizedPhone = cleaned;
    
    // Si empieza con código de país 1 (Estados Unidos/Canadá/República Dominicana)
    if (normalizedPhone.startsWith('1')) {
      // Verificar que tenga el formato correcto (1 + código de área RD + número)
      // Códigos de área de RD: 809, 829, 849
      const areaCode = normalizedPhone.substring(1, 4);
      if (!['809', '829', '849'].includes(areaCode)) {
        setError('El código de área debe ser 809, 829 o 849 (República Dominicana)');
        return;
      }
      if (normalizedPhone.length !== 11) {
        setError('El número debe tener 11 dígitos (1 + código de área + número)');
        return;
      }
    } else {
      // Si no tiene código de país, verificar que sea un número local de RD
      if (normalizedPhone.length === 10) {
        // Verificar código de área
        const areaCode = normalizedPhone.substring(0, 3);
        if (!['809', '829', '849'].includes(areaCode)) {
          setError('El código de área debe ser 809, 829 o 849 (República Dominicana)');
          return;
        }
        // Agregar código de país 1
        normalizedPhone = '1' + normalizedPhone;
      } else {
        setError('El número debe tener 10 dígitos (código de área + número) o 11 dígitos (1 + código de área + número)');
        return;
      }
    }

    onStartChat(normalizedPhone);
    setPhoneNumber('');
    onClose();
  };

  const handleClose = () => {
    setPhoneNumber('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="new-chat-modal-overlay" onClick={handleClose}>
      <div className="new-chat-modal" onClick={(e) => e.stopPropagation()}>
        <div className="new-chat-header">
          <h2>Nueva conversación</h2>
          <button className="close-button" onClick={handleClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="new-chat-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="phoneNumber">
              Número de WhatsApp <span className="required">*</span>
            </label>
            <input
              type="tel"
              id="phoneNumber"
              value={phoneNumber}
              onChange={(e) => {
                setPhoneNumber(e.target.value);
                setError('');
              }}
              placeholder="8091234567, 8291234567 o 8491234567"
              required
              autoFocus
            />
            <small className="form-help">
              Ingresa un número de República Dominicana (ej: 8091234567, 8291234567, 8491234567 o +18091234567)
            </small>
          </div>

          <div className="form-actions">
            <button type="button" onClick={handleClose} className="cancel-button">
              Cancelar
            </button>
            <button type="submit" className="start-button">
              Iniciar conversación
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewChatModal;

